var Airtable = require('airtable');
var base = new Airtable({apiKey: 'keyuUbgDR5JLrTBJq'}).base('appuRWHocoOP3cGKz');
import axios from "axios";

export default {
  namespaced: true,
  state: {
    users: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    usersMessage: ''
  },
  mutations: {
    RECEIVED_USERS(state, payload) {
      state.users = payload;
      state.isReceiving = false;
    },
    RECEIVING_USERS(state) {
      state.isReceiving = true;
    },
    RECEIVED_USER(state, payload) {
      state = Object.assign(state, {
        users: [...state.users, payload],
        isReceiving: false,
      })
    },
    RECEIVING_USER(state) {
      state.isReceiving = true;
    },
    UPDATED_USER(state, payload) {
      let index = state.users.findIndex(u => u.id === payload.id);
      state = Object.assign(state, {
        users: state.users.map((u, i) => {
          if (i === index) {
            return Object.assign({}, u, payload);
          }
          return u;
        }),
        isUpdating: false,
        usersMessage: 'Users has been updating!',
      })
    },
    UPDATING_USER(state) {
      state.isUpdating = true;
    },
    DELETED_USER(state, payload) {
      let indexToDelete = state.users.findIndex(p => p.id === payload.id);
      let users = [...state.users];
      users.splice(indexToDelete, 1);
      state = Object.assign(state, {
        users: [...users],
        isDeleting: false,
        idToDelete: null,
        usersMessage: 'User has been Deleted!',
      });
    },
    DELETING_USER(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getUsersRequest({dispatch}) {
      dispatch("receivingUsers");
      var usersObject = [];
      base('People')
        .select()
        .eachPage(function page(records, fetchNextPage) {
          usersObject.push(records)
          fetchNextPage();
        },
        function done(err) {
          if (err) { console.error(err); return;}
          const users = usersObject[0].map(user => {
            return user.fields
          });
          console.log(users);
          dispatch("receiveUsers", users);
        });
    },

    loadUserRequest({dispatch}, id) {
     dispatch("receivingUser");
      base('People').find(id).then(res => {
        console.log(res);
        dispatch("receiveUser");
      })
    },

    updateUserRequest({dispatch}, payload) {
      const id = payload.id;
      dispatch("updatingUser");
      axios.put(`/users/${id}`, {id, data: payload}).then(res => {
        dispatch("updateUser", res.data);
      });

      dispatch("receivingUsers");
      axios.get('/users').then(res => {
        dispatch("receiveUsers", res.data.rows);
      })
    },

    createUserRequest({dispatch}, payload) {
      dispatch("receivingUsers");
      base('People').create(payload,
        function(err, records) {
          if(err) {
            console.error(err);
            return;
          }
          records.forEach(function (record) {
            console.log(record.getId());
          });
        }
      );
    },

    deleteUserRequest({dispatch}, payload) {
      dispatch("deletingUser", payload);
      console.log(payload);
      base('People').destroy(payload.id, function(err, deletedRecord) {
        if (err) {
          console.error(err);
          return;
        }
        console.log('Deleted User', deletedRecord.fields.Name)
        dispatch("deleteUser", {id: payload.id})
      })
    },

    receiveUsers({commit}, payload) {
      commit("RECEIVED_USERS", payload)
    },

    receivingUsers({commit}) {
      commit("RECEIVING_USERS")
    },

    receiveUser({commit}, payload) {
      commit("RECEIVED_USER", payload)
    },

    receivingUser({commit}) {
      commit("RECEIVING_USER")
    },

    updateUser({commit}, payload) {
      commit("UPDATED_USER", payload)
    },

    updatingUser({commit}) {
      commit("UPDATING_USER")
    },

    deleteUser({commit}, payload) {
      commit("DELETED_USER", payload)
    },

    deletingUser({commit}, payload) {
      commit("DELETING_USER", payload)
    }
  },
  getters: {
    filterOwner: state => {

      return state.users.fields.role.filter('Owner');
    }
  }
};
